<mat-divider class="ui-grid-reset-divider"
             vertical="true"></mat-divider>
<button (click)="resetFilter()"
        class="ui-grid-dropdown-filter-button ui-grid-reset-button"
        mat-button
        color="primary"
        type="button">
    <span translate>grid_reset_to_defaults</span>
</button>
